import React from 'react';
import GridView from '../../../../../components/elements/GridView/index';
import { CheckmarkFilled, CloseFilled, WarningAltFilled } from '@carbon/icons-react';
import CustomEmpty, { CustomEmptyType } from '../../../../../components/CustomEmpty';

interface DvrHealthReportAlarmLog {
    id: number;
    dvr_health_report_id: number;
    alarm_at: string;
    alarm_id: number;
    alert_type: number;
    alert_text: string;
    status?: string;
}

interface DvrHealthReportAlarmLogProps {
    alarmLogs: DvrHealthReportAlarmLog[];
}

const DvrHealthReportAlarmLog: React.FC<DvrHealthReportAlarmLogProps> = ({
    alarmLogs = []
}) => {
    const logList = alarmLogs.map((log) => {
        let status = (<WarningAltFilled
            size={16}
            fill='#EFB700'
        />);
        if (log.status === 'failed') {
            status = <CloseFilled
                size={16}
                fill='#B81D13'
            />;
        } else if (log.status === 'success') {
            status = <CheckmarkFilled
                size={16}
                fill='#008450'
            />;
        }
        const time = log.alarm_at ? log.alarm_at.split(' ')[1] : '';
        return {
            "Status": status,
            "Time": time,
            "Health_notification": log.alert_text,
        };
    });
    return (
        <div className='dvr-health-report-alarm-log'>
            {logList?.length ? (
                <GridView
                    data={logList}
                    scroll={{
                        x: 'max-content',
                        y: 'calc(30vh)',
                    }}
                    overrideColumnWidths={null}
                    disablePagination
                />
            ) : (
                <>
                    <br />
                    <CustomEmpty type={CustomEmptyType.DvrHealthReport} />
                    <br />
                </>
            )}

        </div>
    );
}

export default DvrHealthReportAlarmLog;